module.exports = __webpack_public_path__ + "img/upload_info_s.8d4b47ed.svg";